<app-header *ngIf="user$ | async as user"></app-header>
<router-outlet></router-outlet>
